import { deleteInvoice } from "../../api/invoiceService";

export const useDeleteInvoice = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInvoice(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete invoice:", error);
            throw error;
        }
    };

    return { remove };
};